/**
 ** @author WZ
 **/
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            BaiduAnalysis: {
                autodraw: { category: 'editor_auto_draw', action: 'click_auto_draw', label: '编辑器_手绘_autodraw' },
                autodraw1: { category: 'editor_auto_draw', action: 'click_complete_draw', label: '编辑器_手绘_完成绘画' },
                autodraw2: { category: 'editor_auto_draw', action: 'click_complete_redraw', label: '编辑器_手绘_重画' },
                autodraw3: { category: 'editor_auto_draw', action: 'click_exit_draw', label: '编辑器_手绘_退出绘画' },
                autodraw6: { category: 'editor_auto_draw', action: 'click_palette', label: '编辑器_手绘_调色板' },
                size16x9: { category: 'canvas_size', action: 'click_16_9', label: '画布尺寸16_9' },
                size9x16: { category: 'canvas_size', action: 'click_9_16', label: '画布尺寸9_16' },
                sound: { category: 'editor_auto_draw', action: 'click_auto_draw', label: '编辑器_智能配音按钮' },
                managementAddBgMusic: { category: 'editor_sound_management', action: 'click_sound_management_add_bg_music', label: '编辑器_声音管理面板_添加背景音乐' },
                managementAddVoice: { category: 'editor_sound_management', action: 'click_sound_management_add_voice', label: '编辑器_声音管理面板_添加录音' },
                adsorb: { category: 'editor_adsorb', action: 'click_set', label: '编辑器_开启吸附' },
                adsorbNo: { category: 'editor_adsorb', action: 'click_cancel', label: '编辑器_关闭吸附' },
                openLens: { category: 'click_open', action: 'click_cancel', label: '镜头特效_开启' },
                closeLens: { category: 'click_close', action: 'click_cancel', label: '镜头特效_关闭' },
            }
        }
    },
    computed: {
        ...mapGetters([
            'TopNav_Size',
            'S_GlobalSearch',
            'S_Scenes',
            'StyleMsg',
            'StyleDataMsg',
            'TOOL',
            'SelectSprites_Msg',
            'SpriteOperation',
            'SpriteBeforeSwap',
            'scoll_Size',
            'Window_Size',
            'UserEquity',
            'UserLevel',
            'UserLevelType',
            'UserMsg',
            'SelectScenes_Msg',
            'IsVipSprites',
        ])
    },
    watch: {
        'StyleMsg': function(val, oldval) { // style赋值

        },
    },
    mounted() {

    },
    methods: {
        materialPushAnalysis(data) {
            let analysis = {
                category: '',
                action: '',
                label: ''
            };
            let styleData = {
                category: '',
                action: '',
                label: ''
            }
            switch (data.type) {
                case 'shapePie':
                case 'shapeLine':
                case 'shapeBar':
                    styleData.action = this.StyleDataMsg.id;
                    styleData.label = this.StyleDataMsg.name;
                    break;
            }
            switch (data.type) {
                case 'style':
                    analysis.category = 'resource_style';
                    analysis.action = 'click_' + data.id;
                    analysis.label = '资源设置_风格_' + data.name;
                    break;
                case 'scenes':
                    analysis.category = 'scene_classification_browsers';
                    analysis.action = 'click_' + data.id;
                    analysis.label = '场景分类浏览量_' + data.name;
                    break;
                case 'Upload':
                    analysis.category = 'resource_panel_upload';
                    analysis.action = 'click_upload';
                    analysis.label = '资源栏_上传';
                    break;
                case 'bgUpload':
                    analysis.category = 'resource_panel_upload';
                    analysis.action = 'click_upload_bg_image';
                    analysis.label = '资源栏_上传_背景图片';
                    break;
                case 'bg':
                    analysis.category = 'background_classification_browsers';
                    analysis.action = 'click_' + data.id;
                    analysis.label = '背景分类浏览量_' + data.name;
                    break;
                case 'bgColor':
                    analysis.category = 'resource_background';
                    analysis.action = 'click_add_background_color';
                    analysis.label = '资源设置_背景_颜色';
                    break;
                case 'imgSettingBg':
                    analysis.category = 'image_setting';
                    analysis.action = 'click_bg_setting';
                    analysis.label = '图片_设置背景';
                    break;
                case 'imgSpritesUpload':
                    analysis.category = 'resource_panel_upload';
                    analysis.action = 'click_upload_image';
                    analysis.label = '资源栏_上传_图片';
                    break;
                case 'videoClick':
                    analysis.category = 'resource_panel_upload';
                    analysis.action = 'click_upload_video';
                    analysis.label = '资源栏_上传_视频';
                    break;
                case 'gifSpritesUpload':
                    analysis.category = 'editor_upload';
                    analysis.action = 'click_upload_gif';
                    analysis.label = '编辑器_上传gif图';
                    break;
                case 'videoGiveup':
                    analysis.category = 'resource_panel_upload';
                    analysis.action = 'click_giveup_upload_video';
                    analysis.label = '资源栏_放弃上传_视频';
                    break;
                case 'videoUpload':
                    analysis.category = 'resource_panel_upload';
                    analysis.action = 'click_upload_video_success';
                    analysis.label = '资源栏_上传_视频_成功';
                    break;
                case 'text':
                    analysis.category = 'text_classification_browsers';
                    analysis.action = 'click_' + data.id;
                    analysis.label = '文字分类浏览量_' + data.name;
                    break;
                case 'text1': // 正文
                    analysis.category = 'resource_text';
                    analysis.action = 'click_add_text';
                    analysis.label = '资源设置_文字_添加正文';
                    break;
                case 'text2': // 副标题
                    analysis.category = 'resource_text';
                    analysis.action = 'click_add_subtitle';
                    analysis.label = '资源设置_文字_添加副标题';
                    break;
                case 'text3': // 标题
                    analysis.category = 'resource_text';
                    analysis.action = 'click_add_title'
                    analysis.label = '资源设置_文字_添加标题';
                    break;
                case 'character':
                    analysis.category = 'character_classification_browsers';
                    analysis.action = 'click_' + data.id;
                    analysis.label = '角色分类浏览量_' + data.name;
                    break;
                case 'props':
                    if (data.itemType == 35) { // 相框
                        analysis.category = 'props_classification_browsers';
                        analysis.action = 'click_props_classification_browsers_frames';
                        analysis.label = '道具分类浏览量_相框';
                    } else {
                        analysis.category = 'props_classification_browsers';
                        analysis.action = 'click_' + data.id;
                        analysis.label = '道具分类浏览量_' + data.name;
                    }
                    break;
                case 'propsSoundSprite':
                    analysis.category = 'resource_prop';
                    analysis.action = 'hover_sound_material';
                    analysis.label = '道具资源_预览有声素材';
                    break;
                case 'shape':
                    analysis.category = 'shape_classification_browsers';
                    analysis.action = 'click_' + data.id;
                    analysis.label = '形状分类浏览量_' + data.name;
                    break;
                case 'shapePie':
                    analysis.category = 'resource_shape';
                    analysis.action = 'click_add_pie_' + styleData.action;
                    analysis.label = '资源设置_形状_图表_饼图_' + styleData.label;
                    break;
                case 'shapeLine':
                    analysis.category = 'resource_shape';
                    analysis.action = 'click_add_line_' + styleData.action;
                    analysis.label = '资源设置_形状_图表_折线图_' + styleData.label;
                    break;
                case 'shapeBar':
                    analysis.category = 'resource_shape';
                    analysis.action = 'click_add_bar_' + styleData.action;
                    analysis.label = '资源设置_形状_图表_柱状图_' + styleData.label;
                    break;
                case 'music':
                    analysis.category = 'music_classification_browsers';
                    analysis.action = 'click_' + data.id;
                    analysis.label = '音乐分类浏览量_' + data.name;
                    break;
                case 'musicBgUpload':
                    analysis.category = 'resource_panel_upload';
                    analysis.action = 'click_upload_bg_music';
                    analysis.label = '资源栏_上传_背景音乐';
                    break;
                case 'musicRecordUpload':
                    analysis.category = 'resource_panel_upload';
                    analysis.action = 'click_upload_record';
                    analysis.label = '资源栏_上传_录音';
                    break;
                case 'autodraw4':
                    analysis.category = 'editor_auto_draw';
                    analysis.action = 'click_quick_exit_draw';
                    analysis.label = '编辑器_手绘_直接退出';
                    break;
                case 'autodraw5':
                    analysis.category = 'editor_auto_draw';
                    analysis.action = 'click_save_exit_draw';
                    analysis.label = '编辑器_手绘_保存并退出';
                    break;
                case 'gridlines1':
                    analysis.category = 'editor_gridlines';
                    analysis.action = 'click_open_gridlines';
                    analysis.label = '编辑器其他_开启网格线';
                    break;
                case 'gridlines':
                    analysis.category = 'editor_others';
                    analysis.action = 'click_close_gridlines';
                    analysis.label = '编辑器其他_关闭网格线';
                    break;
                case 'autodrawVip':
                    analysis.category = 'upgrade_members';
                    analysis.action = 'click_editor_vip_senior_upgrade_autodraw';
                    analysis.label = '升级会员_编辑器_VIP_高级会员_autodraw';
                    break;
                case 'upgradeAidubVip':
                    analysis.category = 'upgrade_members';
                    analysis.action = 'click_editor_vip_senior_upgrade_aidub';
                    analysis.label = '升级会员_编辑器_VIP_高级会员_智能配音';
                    break;
                case 'watermarkVip':
                    analysis.category = 'upgrade_members';
                    analysis.action = 'click_export_watermark_upgrade_vip';
                    analysis.label = '升级会员_导出_水印_升级会员';
                    break;
                case 'videoUpgradevip':
                    analysis.category = 'upgrade_members';
                    analysis.action = 'click_export_video_quality_upgrade_vip';
                    analysis.label = '升级会员_导出_视频画质_升级会员';
                    break;
                case 'toolSoundListen':
                    analysis.category = 'resource_music';
                    analysis.action = 'click_listen_music';
                    analysis.label = '资源设置_背景音乐_试听';
                    break;
                case 'toolSoundDelete':
                    analysis.category = 'resource_music';
                    analysis.action = 'click_delete_music';
                    analysis.label = '资源设置_背景音乐_删除';
                    break;
                case 'toolSoundLoop':
                    analysis.category = 'resource_music';
                    analysis.action = 'click_loop_music';
                    analysis.label = '资源设置_背景音乐_循环';
                    break;
                case 'selectStyle':
                    analysis.category = 'resource_style';
                    analysis.action = 'click_editor_style';
                    analysis.label = '编辑器_风格选择';
                    break;
                case 'wordart':
                    analysis.category = 'text_classification_wordart';
                    analysis.action = 'click_wordart';
                    analysis.label = '文字_艺术字分类';
                    break;
                case 'bgLandscape':
                    analysis.category = 'resource_background_landscape';
                    analysis.action = 'click_tab_of_landscape';
                    analysis.label = '背景_横屏';
                    break;
                case 'bgPortrait':
                    analysis.category = 'resource_background_portrait';
                    analysis.action = 'click_tab_of_portrait';
                    analysis.label = '背景_竖屏';
                    break;
                case 'sceneLandscape':
                    analysis.category = 'resource_scene_landscape';
                    analysis.action = 'click_tab_of_landscape';
                    analysis.label = '场景页_横版';
                    break;
                case 'scenePortrait':
                    analysis.category = 'resource_scene_portrait';
                    analysis.action = 'click_tab_of_portrait';
                    analysis.label = '场景页_竖版';
                    break;
                case 'personalSetting':
                    analysis.category = 'resource_management';
                    analysis.action = 'click_resource_management';
                    analysis.label = '批量管理';
                    break;
                case 'filterSpritesall':
                    analysis.category = 'resources_classification_browsers';
                    analysis.action = 'click_resources_classification_of_all';
                    analysis.label = '浏览全部素材';
                    break;
                case 'filterSpritesstatic':
                    analysis.category = 'resources_classification_browsers';
                    analysis.action = 'click_resources_classification_of_static_resources';
                    analysis.label = '浏览静态素材';
                    break;
                case 'filterSpritesdynamic':
                    analysis.category = 'resources_classification_browsers';
                    analysis.action = 'click_resources_classification_of_dynamic_resources';
                    analysis.label = '浏览动态素材';
                    break;
                case 'soundBtnSetaudio':
                    analysis.category = 'music_classification_add_recording';
                    analysis.action = 'click_music_classification_add_recording';
                    analysis.label = '声音_添加录音';
                    break;
                case 'versionUpdateHelp':
                    analysis.category = 'click_update_reminder_in_help';
                    analysis.action = 'update_reminder';
                    analysis.label = '帮助_功能更新';
                    break;
                case 'NewVersionClose':
                    analysis.category = 'click_close_update_reminder_on_the_banner';
                    analysis.action = 'update_reminder';
                    analysis.label = '功能更新横幅提示_关闭';
                    break;
                case 'NewVersionOn':
                    analysis.category = 'click_update_reminder_on_the_banner';
                    analysis.action = 'update_reminder';
                    analysis.label = '功能更新横幅提示';
                    break;
                case 'openSlideBoxtemplate':
                    analysis.category = 'resource_area';
                    analysis.action = 'click_template';
                    analysis.label = '素材资源区_点击_模板';
                    break;
                case 'openSlideBoxscenes':
                    analysis.category = 'click_scene_classification';
                    analysis.action = 'scene_classification';
                    analysis.label = '场景页分类';
                    break;
                case 'openSlideBoxbg':
                    analysis.category = 'click_bg_classification';
                    analysis.action = 'bg_classification';
                    analysis.label = '背景分类';
                    break;
                case 'openSlideBoxtext':
                    analysis.category = 'click_text_classification';
                    analysis.action = 'text_classification';
                    analysis.label = '文字分类';
                    break;
                case 'openSlideBoxcharacters':
                    analysis.category = 'click_scene_classification';
                    analysis.action = 'scene_classification';
                    analysis.label = '角色分类';
                    break;
                case 'openSlideBoxprops':
                    analysis.category = 'click_props_classification';
                    analysis.action = 'props_classification';
                    analysis.label = '道具分类';
                    break;
                case 'openSlideBoxshapes':
                    analysis.category = 'click_shape_classification';
                    analysis.action = 'shape_classification';
                    analysis.label = '形状分类';
                    break;
                case 'openSlideBoxgif':
                    analysis.category = 'click_gif_classification';
                    analysis.action = 'gif_classification';
                    analysis.label = '“GIF图”分类';
                    break;
                case 'openSlideBoxsound':
                    analysis.category = 'click_music_classification';
                    analysis.action = 'music_classification';
                    analysis.label = '声音分类';
                    break;
                case 'openSlideBoxpersonal':
                    analysis.category = 'click_mine_classification';
                    analysis.action = 'mine_classification';
                    analysis.label = '“我的”分类';
                    break;
                case 'openSlideBoxteam':
                    analysis.category = 'click_sharing_classification';
                    analysis.action = 'sharing_classification';
                    analysis.label = '"团队“分类';
                    break;
                case 'cropSoundBoxOn':
                    analysis.category = 'editor_sound_management';
                    analysis.action = 'click_bgm_cutting';
                    analysis.label = '声音管理_背景音乐_剪辑';
                    break;
                case 'cropSoundBoxOff':
                    analysis.category = 'editor_sound_management';
                    analysis.action = 'click_bgm_cutting_back';
                    analysis.label = '声音管理_背景音乐_剪辑_返回';
                    break;
                case 'cropSoundBtnleft':
                    analysis.category = 'editor_sound_management';
                    analysis.action = 'click_bgm_cutting_left';
                    analysis.label = '声音管理_背景音乐_剪辑_左裁剪框';
                    break;
                case 'cropSoundBtnright':
                    analysis.category = 'editor_sound_management';
                    analysis.action = 'click_bgm_cutting_right';
                    analysis.label = '声音管理_背景音乐_剪辑_右裁剪框';
                    break;
                case 'cropSoundListen':
                    analysis.category = 'editor_sound_management';
                    analysis.action = 'click_bgm_cutting_listen';
                    analysis.label = '声音管理_背景音乐_剪辑_试听';
                    break;
                case 'personalAllIn':
                    analysis.category = 'resource_management';
                    analysis.action = 'click_select_all';
                    analysis.label = '管理_全选';
                    break;
                case 'personalAllOut':
                    analysis.category = 'resource_management';
                    analysis.action = 'click_unselect_all';
                    analysis.label = '管理_取消全选';
                    break;
            };
            this.$analysis(analysis);
        },
        materialPushAnalysisTwo(data) {
            let analysis = {};
            switch (data) {
                case 'layerSettingFSbottom':
                    analysis.category = 'materCombination_layer_setting';
                    analysis.action = 'click_top_layer';
                    analysis.label = '素材组合_图层设置_置顶';
                    break;
                case 'layerSettingFSnext':
                    analysis.category = 'materCombination_layer_setting';
                    analysis.action = 'click_up_layer';
                    analysis.label = '素材组合_图层设置_上移';
                    break;
                case 'layerSettingFStop':
                    analysis.category = 'materCombination_layer_setting';
                    analysis.action = 'click_bottom_layer';
                    analysis.label = '素材组合_图层设置_置底';
                    break;
                case 'layerSettingFSpre':
                    analysis.category = 'materCombination_layer_setting';
                    analysis.action = 'click_down_layer';
                    analysis.label = '素材组合_图层设置_下移';
                    break;
                case 'spritesAlignFSleft':
                    analysis.category = 'materCombination_align_setting';
                    analysis.action = 'click_align_left';
                    analysis.label = '素材组合_对齐设置_左对齐';
                    break;
                case 'spritesAlignFSlevel-center':
                    analysis.category = 'materCombination_align_setting';
                    analysis.action = 'click_align_center';
                    analysis.label = '素材组合_对齐设置_水平居中';
                    break;
                case 'spritesAlignFSright':
                    analysis.category = 'materCombination_align_setting';
                    analysis.action = 'click_align_right';
                    analysis.label = '素材组合_对齐设置_右对齐';
                    break;
                case 'spritesAlignFStop':
                    analysis.category = 'materCombination_align_setting';
                    analysis.action = 'click_align_top';
                    analysis.label = '素材组合_对齐设置_顶对齐';
                    break;
                case 'spritesAlignFSvertical-center':
                    analysis.category = 'materCombination_align_setting';
                    analysis.action = 'click_align_middle';
                    analysis.label = '素材组合_对齐设置_垂直对齐';
                    break;
                case 'spritesAlignFSbottom':
                    analysis.category = 'materCombination_align_setting';
                    analysis.action = 'click_align_bottom';
                    analysis.label = '素材组合_对齐设置_底对齐';
                    break;
                case 'spritesAlignFSlevel-equal':
                    analysis.category = 'materCombination_align_setting';
                    analysis.action = 'click_distribute_horizontally';
                    analysis.label = '素材组合_对齐设置_水平等间距';
                    break;
                case 'spritesAlignFSvertical-equal':
                    analysis.category = 'materCombination_align_setting';
                    analysis.action = 'click_distribute_vertically';
                    analysis.label = '素材组合_对齐设置_垂直等间距';
                    break;
                case 'process-spin':
                    analysis.category = 'materCombination_setting';
                    analysis.action = 'drag_roatate_btn';
                    analysis.label = '拖拽_素材组合_旋转按钮';
                    break;
                case 'process-zoom':
                    analysis.category = 'materCombination_setting';
                    analysis.action = 'drag_scale_btn';
                    analysis.label = '拖拽_素材组合_放缩按钮';
                    break;
                case 'delVipBtn':
                    analysis.category = 'vip_list';
                    analysis.action = 'click_vip_btn';
                    analysis.label = 'VIP权益_入口';
                    break;
                case 'personalTabFS':
                    analysis.category = 'resources_area_mine';
                    analysis.action = 'click_collect_tab';
                    analysis.label = '我的资源_收藏资源tab';
                    break;
                case 'collectionSpritePersonalDel':
                    analysis.category = 'resources_area_mine';
                    analysis.action = 'click_cancel_collect';
                    analysis.label = '我的资源_取消收藏素材';
                    break
                case 'collectionSpriteDel':
                    analysis.category = 'resources_area';
                    analysis.action = 'click_cancel_collect';
                    analysis.label = '资源区_素材_取消收藏';
                    break
                case 'collectionSpritePersonalAdd':
                    analysis.category = 'resources_area_mine';
                    analysis.action = 'click_collect';
                    analysis.label = '我的资源_收藏素材';
                    break
                case 'collectionSpriteAdd':
                    analysis.category = 'resources_area';
                    analysis.action = 'click_collect';
                    analysis.label = '资源区_素材_收藏';
                    break

            }
            this.$analysis(analysis);
        }

    },
    components: {

    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/analysis/materialBu.js